import { Action } from '@ngrx/store';
import { MediaStateChangedEvent } from '../../../shared/events/media-state-changed.event';

export enum MediaActionTypes {
  MEDIA_SIGNALR_STATE_CHANGED = '[Media API] Media State Changed',
  MEDIA_EFFECT_MEDIA_RESETTED = '[Media Effect] Media Resetted',
  MEDIA_API_NO_MEDIA = '[Media API] No media',
}

export class MediaSignalRStateChanged implements Action {
  readonly type = MediaActionTypes.MEDIA_SIGNALR_STATE_CHANGED;

  constructor(public payload: { mediaState: MediaStateChangedEvent }) {}
}

export class MediaEffectMediaResetted implements Action {
  readonly type = MediaActionTypes.MEDIA_EFFECT_MEDIA_RESETTED;

  constructor(public payload: { mediaState: MediaStateChangedEvent }) {}
}

export class MediaApiNoMedia implements Action {
  readonly type = MediaActionTypes.MEDIA_API_NO_MEDIA;
}

export type MediaActionsUnion = MediaSignalRStateChanged | MediaEffectMediaResetted;
